var _circle, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditPancilWithBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 26,
    r: 26,
    fill: "#38879F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5419 33.5196C18.9319 33.5196 18.3619 33.3096 17.9519 32.9196C17.4319 32.4296 17.1819 31.6896 17.2719 30.8896L17.6419 27.6496C17.7119 27.0396 18.0819 26.2296 18.5119 25.7896L26.7219 17.0996C28.7719 14.9296 30.9119 14.8696 33.0819 16.9196C35.2519 18.9696 35.3119 21.1096 33.2619 23.2796L25.0519 31.9696C24.6319 32.4196 23.8519 32.8396 23.2419 32.9396L20.0219 33.4896C19.8519 33.4996 19.7019 33.5196 19.5419 33.5196ZM29.9319 16.9096C29.1619 16.9096 28.4919 17.3896 27.8119 18.1096L19.6019 26.8096C19.4019 27.0196 19.1719 27.5196 19.1319 27.8096L18.7619 31.0496C18.7219 31.3796 18.8019 31.6496 18.9819 31.8196C19.1619 31.9896 19.4319 32.0496 19.7619 31.9996L22.9819 31.4496C23.2719 31.3996 23.7519 31.1396 23.9519 30.9296L32.1619 22.2396C33.4019 20.9196 33.8519 19.6996 32.0419 17.9996C31.2419 17.2296 30.5519 16.9096 29.9319 16.9096Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3404 24.9508C31.3204 24.9508 31.2904 24.9508 31.2704 24.9508C28.1504 24.6408 25.6404 22.2708 25.1604 19.1708C25.1004 18.7608 25.3804 18.3808 25.7904 18.3108C26.2004 18.2508 26.5804 18.5308 26.6504 18.9408C27.0304 21.3608 28.9904 23.2208 31.4304 23.4608C31.8404 23.5008 32.1404 23.8708 32.1004 24.2808C32.0504 24.6608 31.7204 24.9508 31.3404 24.9508Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35 36.75H17C16.59 36.75 16.25 36.41 16.25 36C16.25 35.59 16.59 35.25 17 35.25H35C35.41 35.25 35.75 35.59 35.75 36C35.75 36.41 35.41 36.75 35 36.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPancilWithBg);
export default __webpack_public_path__ + "static/media/edit-pancil-with-bg.d31f73cbb24c752a5a8ab3449665645c.svg";
export { ForwardRef as ReactComponent };